<div class="kgr-pageHeader__inner">
  <button class="kgr-pageHeader__item kgr-clickable kgr-clickable--touchy" type="button" (click)="onMainMenuToggleClick($event)">
    <div [class.is-open]="state() === 'mainMenuOpen'" class="kgr-menuToggle">
      <span class="kgr-menuToggle__line"></span>
      <span class="kgr-menuToggle__line"></span>
      <span class="kgr-menuToggle__line"></span>
    </div>
  </button>
  @if (displayBackLink$ | async) {
    <div class="kgr-pageHeader__item">
      <button type="button" tabindex="0" class="kgr-clickable kgr-clickable--touchy" (click)="onBackLinkClick()">
        <svg kgrIcon="arrow-back" class="kgr-postfix__icon"></svg>
      </button>
    </div>
  }
  <div class="kgr-pageHeader__item kgr-pageHeader__item--grow title" id="kgr-pageTitle"></div>
  <button class="kgr-pageHeader__item kgr-clickable kgr-clickable--touchy" type="button" (click)="onUserMenuToggleClick($event)">
    <kgr-profile-image
      [imageUrl]="user?.hasProfileImage ? (user.profileImageApiUrl | apiImageUrl: 'profile_image_m' : user._cacheBuster | async) : null"
      [small]="true"
    ></kgr-profile-image>
  </button>
</div>
